import { Table, Button } from 'antd';
import React, { Component } from 'react';
import { columns8 } from './data';

class index extends Component {
    render() {
        const { data, print, onExport } = this.props;
        return (
            <div>
                <Table
                    columns={columns8(print)}
                    dataSource={data.data}
                    size="middle"
                    bordered
                    pagination={false}
                    id="table5_10_8"
                    className="content"
                    scroll={print ? {} : { x: 1800, y: false }}
                    rowKey={v => v.sort}
                />
                {print ? null : <Button
                    className='export-btn'
                    type="primary"
                    onClick={() => onExport('table5_10_8', 'Key Performance Indicator 关键数据')}
                >导出Excel</Button>}
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-10/Table5_10_8.js